import { RenderModule } from 'holocron';
import PropTypes from 'prop-types';
import React from 'react';

const BasicError = ({ route: { code } }) => (
  <RenderModule moduleName="axp-error-message" props={{ code }} />
);

BasicError.propTypes = {
  route: PropTypes.shape({
    header: PropTypes.string,
    code: PropTypes.string.isRequired,
  }).isRequired,
};

export default BasicError;
